import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Calendar, Mail, CheckCircle } from 'lucide-react';
export function ProfileSetupModal() {
  const {
    completeProfile
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    territorio: 'Madrid Centro'
  });
  const [calendarConnected, setCalendarConnected] = useState(false);
  const [emailConnected, setEmailConnected] = useState(false);
  const [days, setDays] = useState({
    L: true,
    M: true,
    X: true,
    J: true,
    V: true,
    S: false,
    D: false
  });
  const [timeRange, setTimeRange] = useState({
    start: '09:00',
    end: '18:00'
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name) return;
    setLoading(true);
    try {
      await completeProfile({
        ...formData,
        horario: {
          days,
          timeRange
        },
        calendarConnected,
        emailConnected
      });
    } finally {
      setLoading(false);
    }
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-76">
      <div className="bg-growthly-surface w-full max-w-lg rounded-[12px] shadow-[0_6px_18px_rgba(0,0,0,0.45)] border border-white/5 p-6 max-h-[90vh] overflow-y-auto" data-id="element-77">
        <h2 className="text-[22px] font-semibold text-white mb-2" data-id="element-78">
          Configura tu cuenta
        </h2>
        <p className="text-[14px] text-growthly-muted mb-6" data-id="element-79">
          Completa tu perfil de setter para empezar a agendar.
        </p>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-80">
          <div data-id="element-81">
            <label className="block text-[12px] uppercase text-growthly-muted mb-1.5" data-id="element-82">
              Nombre completo
            </label>
            <input type="text" required value={formData.name} onChange={e => setFormData(d => ({
            ...d,
            name: e.target.value
          }))} className="w-full h-11 px-4 bg-[#141414] border border-white/5 rounded-lg text-white focus:border-growthly-amber focus:outline-none transition-colors" placeholder="Ej. Juan Pérez" data-id="element-83" />
          </div>

          <div data-id="element-84">
            <label className="block text-[12px] uppercase text-growthly-muted mb-1.5" data-id="element-85">
              Territorio
            </label>
            <select value={formData.territorio} onChange={e => setFormData(d => ({
            ...d,
            territorio: e.target.value
          }))} className="w-full h-11 px-4 bg-[#141414] border border-white/5 rounded-lg text-white focus:border-growthly-amber focus:outline-none transition-colors appearance-none" data-id="element-86">
              <option data-id="element-87">Madrid Centro</option>
              <option data-id="element-88">Madrid Norte</option>
              <option data-id="element-89">Madrid Sur</option>
              <option data-id="element-90">Barcelona</option>
              <option data-id="element-91">Valencia</option>
              <option data-id="element-92">Sevilla</option>
              <option data-id="element-93">Bilbao</option>
            </select>
          </div>

          <div data-id="element-94">
            <label className="block text-[12px] uppercase text-growthly-muted mb-1.5" data-id="element-95">
              Horario semanal
            </label>
            <div className="bg-[#141414] border border-white/5 rounded-lg p-4 space-y-4" data-id="element-96">
              <div className="flex gap-2 justify-between" data-id="element-97">
                {Object.entries(days).map(([day, checked]) => <button key={day} type="button" onClick={() => setDays(d => ({
                ...d,
                [day]: !checked
              }))} className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${checked ? 'bg-growthly-amber text-black' : 'bg-white/5 text-growthly-muted hover:bg-white/10'}`} data-id="element-98">
                    {day}
                  </button>)}
              </div>
              <div className="flex gap-4 items-center" data-id="element-99">
                <input type="time" value={timeRange.start} onChange={e => setTimeRange(r => ({
                ...r,
                start: e.target.value
              }))} className="flex-1 h-10 px-3 bg-white/5 border border-white/5 rounded text-white focus:outline-none" data-id="element-100" />
                <span className="text-growthly-muted" data-id="element-101">a</span>
                <input type="time" value={timeRange.end} onChange={e => setTimeRange(r => ({
                ...r,
                end: e.target.value
              }))} className="flex-1 h-10 px-3 bg-white/5 border border-white/5 rounded text-white focus:outline-none" data-id="element-102" />
              </div>
            </div>
          </div>

          <div className="space-y-3 pt-2 border-t border-white/5" data-id="element-103">
            <button type="button" onClick={() => setCalendarConnected(true)} className={`w-full h-11 px-4 rounded-lg border flex items-center justify-center gap-2 transition-colors ${calendarConnected ? 'border-[#27AE60]/30 bg-[#27AE60]/10 text-[#27AE60]' : 'border-white/10 bg-transparent text-white hover:bg-white/5'}`} data-id="element-104">
              {calendarConnected ? <CheckCircle size={18} data-id="element-105" /> : <Calendar size={18} data-id="element-106" />}
              {calendarConnected ? 'Google Calendar conectado' : 'Conectar Google Calendar'}
            </button>

            <button type="button" onClick={() => setEmailConnected(true)} className={`w-full h-11 px-4 rounded-lg border flex items-center justify-center gap-2 transition-colors ${emailConnected ? 'border-[#27AE60]/30 bg-[#27AE60]/10 text-[#27AE60]' : 'border-white/10 bg-transparent text-white hover:bg-white/5'}`} data-id="element-107">
              {emailConnected ? <CheckCircle size={18} data-id="element-108" /> : <Mail size={18} data-id="element-109" />}
              {emailConnected ? 'Correo conectado' : 'Conectar correo (Gmail/Outlook)'}
            </button>
          </div>

          <div className="pt-4" data-id="element-110">
            <button type="submit" disabled={loading || !formData.name} className="w-full h-11 bg-white text-[#0B0B0B] font-medium rounded-lg hover:bg-gray-100 disabled:opacity-50 transition-colors flex items-center justify-center" data-id="element-111">
              {loading ? <div className="w-5 h-5 border-2 border-[#0B0B0B]/20 border-t-[#0B0B0B] rounded-full animate-spin" data-id="element-112" /> : 'Guardar y continuar'}
            </button>
          </div>
        </form>
      </div>
    </div>;
}